const topic ={
    // 设备实时数据主题
    dev(prefix,station,dev){
        return prefix+'/'+station+'/'+dev
    },

    //曲线数据推送主题
    curve(curveCode){
        return 'ls/pm/curve/'+ curveCode
    },

    //拓扑图实时数据主题
    topology(topoCode){
        return 'ls/pm/tsd/rtd'+ topoCode
    },

    //告警数据主题
    alarm(statCode){
        return 'ls/pm/msg/alarm/'+ statCode
    }
}
export default topic